// src/pages/AddBlogPage.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { getToken, isTokenValid } from "../utils/auth";
import API_BASE_URL from "../config";

export default function AddBlogPage() {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [author, setAuthor] = useState("");
  const [image, setImage] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isTokenValid()) {
      navigate("/adminlogin");
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title || !content || !author) {
      alert("All fields are required");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("title", title);
      formData.append("content", content);
      formData.append("author", author);
      if (image) formData.append("image", image);

      await axios.post(`${API_BASE_URL}/posts`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${getToken()}`,
        },
      });

      alert("Blog added successfully");
      setTitle("");
      setContent("");
      setAuthor("");
      setImage(null);
    } catch (err) {
      console.error(err);
      alert("Error creating blog");
    }
  };
  const handleLogout = () => {
    localStorage.removeItem("token"); // remove the saved token
    navigate("/adminlogin"); // redirect to login page
  };

  return (
    <>
      <nav className="navbar p-3">
        <div className="container-fluid">
          <div className="d-flex">
            <a className="navbar-brand brand-name">Hello, Admin</a>
          </div>
          <div className="d-flex">
            <button
              className="btn btn-outline-light rounded-pill px-4"
              onClick={handleLogout}
            >
              Logout
            </button>
          </div>
        </div>
      </nav>
      <div className="">
        <div className="container pt-5">
          <h3 className="fw-normal">Add Blog</h3>
        </div>
      </div>
      <div className="container">
        <form onSubmit={handleSubmit} className="py-4">
          <label className="form-label text-white pt-2">Title</label>
          <input
            type="text"
            placeholder="Enter a title"
            className="form-control text-white"
            style={{
              backgroundColor: "transparent",
              borderColor: "grey",
            }}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <label className="form-label text-white pt-2">Content</label>
          <textarea
            placeholder="Enter content"
            className="form-control text-white"
            style={{
              backgroundColor: "transparent",
              borderColor: "grey",
            }}
            rows="4"
            value={content}
            onChange={(e) => setContent(e.target.value)}
          />
          <label className="form-label text-white pt-2">Author</label>
          <input
            type="text"
            placeholder="Enter author"
            className="form-control text-white "
            style={{
              backgroundColor: "transparent",
              borderColor: "grey",
            }}
            value={author}
            onChange={(e) => setAuthor(e.target.value)}
          />
          <input
            className="pt-4"
            type="file"
            accept="image/*"
            onChange={(e) => setImage(e.target.files[0])}
          />

          {/* <button
          type="submit"
          className="btn btn-light rounded-pill px-4 py-2"
        >
          Add Blog
        </button>
         */}
          <div className="d-flex gap-2 pt-3">
            <button
              type="submit"
              className="btn btn-light rounded-pill px-4 py-2"
            >
              Add Blog
            </button>

            <button
              type="button"
              className="btn btn-outline-light rounded-pill px-4 py-2"
              onClick={() => navigate("/adminView")}
            >
              Go to Blogs
            </button>
          </div>
        </form>
        {/* <button
        className="btn btn-outline-light rounded-pill px-4 py-2 mx-2"
        onClick={() => navigate("/adminView")}
      >
        Go to Blogs
      </button> */}
      </div>
    </>
  );
}
